module.exports = __webpack_public_path__ + "img/icon-music-title.d3f5a8e8.png";